/*
 *
 * Footer
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 25-Nov-2024
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  copyright: <PortalMessage id='t.app.footer.copyright' defaultMessage='© Nexi Group. All Rights Reserved.' />
}

export const messages = defineMessages({
  privacy: {
    id: 't.app.footer.privacy',
    defaultMessage: 'Privacy'
  },
  cookies: {
    id: 't.app.footer.cookies',
    defaultMessage: 'Cookies'
  }
})

export default formattedMessage
